import React from "react";
import { withApollo, type WithApolloClient } from "@apollo/client/react/hoc";
import { connect, type ConnectedProps } from "react-redux";
import { Card, Row, Col } from "react-bootstrap";
import { push } from "store/actions/router";
import { createErrorSelector } from "store/selectors";
import { employerConstants } from "actions/types";
import { FiUsers } from "react-icons/fi";
import type { RootState } from "types/state";

import Alert from "components/Alert";
import IconMessageCard from "components/IconMessageCard";

import "./Employees.scss";

const actions = [employerConstants.GET_EMPLOYER_GROUPS];
const errorSelector = createErrorSelector(actions);

const mapStateToProps = (state: RootState) => {
  return {
    error: errorSelector(state),
  };
};

const mapDispatchToProps = {
  push,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = WithApolloClient<PropsFromRedux>;

const MissingEmployerGroup = (props: Props) => {
  return (
    <div className="download-employee-template">
      <div className="main-content">
        <Row>
          <Col>
            <Card>
              <IconMessageCard
                icon={<FiUsers color="white" stroke="#60A4BF" size={16} />}
                header={"Looks like you do not have any groups linked."}
                subheader="You must first add a group before you can add employees."
                actionText={"Add group"}
                onClick={() => {
                  props.push("/dashboard/company/group");
                }}
              />
              {props.error && <Alert type="error" msg={props.error} />}
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default connector(withApollo<Props>(MissingEmployerGroup));
